import React from "react";

const cx = (...classes) => classes.filter(Boolean).join(" ");

/**
 * 1–N rating buttons for public surveys. Each button is a toggle (`aria-pressed`);
 * the selected value is filled, the rest outlined.
 *
 * @param {object} props
 * @param {number|null} props.value
 * @param {(value: number) => void} props.onChange
 * @param {string} props.labelledBy id of the question text that names the group.
 * @param {string} [props.lowLabel] Caption under the first value.
 * @param {string} [props.highLabel] Caption under the last value.
 * @param {number} [props.max=5]
 */
const RatingScale = ({ value, onChange, labelledBy, lowLabel, highLabel, max = 5 }) => {
  const values = Array.from({ length: max }, (_, i) => i + 1);

  return (
    <div>
      <div role="group" aria-labelledby={labelledBy} className="flex gap-2 sm:gap-3">
        {values.map((n) => {
          const selected = value === n;
          return (
            <button
              key={n}
              type="button"
              onClick={() => onChange(n)}
              aria-pressed={selected}
              aria-label={`${n} of ${max}`}
              className={cx(
                "h-12 flex-1 rounded-control border text-base font-bold transition-colors focus-ring sm:h-14",
                selected
                  ? "border-primary bg-primary text-primary-fg"
                  : "border-line bg-surface text-fg hover:bg-surface-subtle"
              )}
            >
              {n}
            </button>
          );
        })}
      </div>
      {(lowLabel || highLabel) && (
        <div className="mt-2 flex justify-between gap-4 text-xs text-fg-muted">
          <span>{lowLabel}</span>
          <span className="text-right">{highLabel}</span>
        </div>
      )}
    </div>
  );
};

export default RatingScale;
